// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
    "customer": {
        "auth_token": "ZQPHltFnQ7vLMftO",
        "mobile": "7983399314"
    }
  };

export {
  dummyResponse ,
}
/* No side effect */
